/**
 * * Получение appWebSettings
 * @param path Путь
 */
export const fetchAppWebSettings = async (
  path: string
): Promise<Record<string, string> | undefined> => {
  const startAuthPart = document.URL.indexOf("//") + 2;
  const endAuthPart = document.URL.indexOf("@");

  const time = new Date().getTime();

  let fetchOptions = {};
  let fetchUrl = `${location.protocol}//${path}?v=${time}`;

  if (endAuthPart >= 0) {
    fetchOptions = {
      headers: new Headers({
        Authorization:
          "Basic " +
          window.btoa(document.URL.substring(startAuthPart, endAuthPart)),
        "Content-Type": "application/json",
      }),
    };
  }

  let settingsItem = sessionStorage.getItem("appWebSettings");
  let appWebSettings;
  if (
    settingsItem &&
    (location.hostname == "localhost" || settingsItem != "{}")
  ) {
    appWebSettings = JSON.parse(settingsItem);
  } else {
    appWebSettings = fetch(fetchUrl, fetchOptions).then(async (res) => {
      return await res.text().then((result) => {
        return JSON.parse(result);
      });
    });
    sessionStorage.setItem("appWebSettings", JSON.stringify(appWebSettings));
  }

  return appWebSettings;
};

/**Установка favicon */
export const setFavicon = () => {
  const favicon = document.createElement("link");
  favicon.rel = "icon";
  favicon.href = "/tslogo.ico";
  document.head.appendChild(favicon);
};
